import { Box, Flex, media, selectTheme, styled } from '@creditas-ui/react';
import { ModalRoot } from '@creditas-ui/modal';

export const ContactCard = styled.button`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;

  height: 112px;
  width: 112px;

  padding: 16px;

  background-color: ${selectTheme('colors.neutral.0')};

  border: 1px solid ${selectTheme('colors.neutral.15')};
  border-radius: ${selectTheme('radius.lg')};

  cursor: pointer;
`;

export const CustomModalRoot = styled(ModalRoot)`
  ${media.down('2xl')} {
    position: absolute;

    bottom: 0;
    width: 100%;

    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const CustomFlex = styled(Flex)`
  gap: 16px;

  min-width: 300px;

  ${media.up('3xl')} {
    gap: 24px;

    margin: ${selectTheme('spacingY.8xl')} 0 ${selectTheme('spacingY.16xl')};
  }
`;

export const CustomModalBody = styled(Box)`
  padding: ${selectTheme('spacingY.5xl')} ${selectTheme('spacingY.5xl')} ${selectTheme('spacingY.8xl')};

  @media only screen and (max-device-width: 1280px) and (orientation: landscape) {
    height: 250px;

    overflow: scroll;
  }

  ${media.up('5xl')} {
    padding: ${selectTheme('spacingX.5xl')} ${selectTheme('spacingY.6xl')} ${selectTheme('spacingX.12xl')}
      ${selectTheme('spacingY.6xl')};
  }
`;
